import { render, staticRenderFns } from "./DataExportModal.vue?vue&type=template&id=d95b1ee2"
import script from "./DataExportModal.vue?vue&type=script&lang=js"
export * from "./DataExportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports